import { render } from "./WorkspaceConvidado.vue?vue&type=template&id=f3eff5e8&scoped=true"
import script from "./WorkspaceConvidado.vue?vue&type=script&lang=js"
export * from "./WorkspaceConvidado.vue?vue&type=script&lang=js"

import "./WorkspaceConvidado.vue?vue&type=style&index=0&id=f3eff5e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3eff5e8"]])

export default __exports__